import React from 'react';
import I18n from 'i18n-js';
import ErrorMessage from './payout_method_error_message';

export interface Props {
  paypalAccountLink: string;
  userAttributes: { firstName: string; lastName: string };
  formPrefix: string;
  errorMessages: string[];
  createdAt: string;
}

class PaypalProfile extends React.Component<Props> {
  nameForField(fieldName) {
    return `${this.props.formPrefix}[${fieldName}]`;
  }

  get hasErrors() {
    return this.props.errorMessages.length > 0;
  }

  renderProfile() {
    if (this.props.createdAt) {
      return (
        <div dangerouslySetInnerHTML={{ __html: this.props.paypalAccountLink }} />
      );
    }

    return (
      <div>
        {this.hasErrors &&
          <ErrorMessage message={this.props.errorMessages.join('. ')} />
        }
        <div className="form-group mb-0">
          <div className="form-group__header">
            <label htmlFor={this.nameForField('email')}>
              {I18n.t('discovery.payoutMethod.paypalEmailLabel')}
            </label>
          </div>
          <div className="form-group__fields">
            <input
              value={this.props.userAttributes.firstName}
              type="hidden"
              name={this.nameForField('first_name')}
            />
            <input
              value={this.props.userAttributes.lastName}
              type="hidden"
              name={this.nameForField('last_name')}
            />
            <input
              required
              type="text"
              name={this.nameForField('email')}
              id={this.nameForField('email')}
            />
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div data-paypal-profile-form>
        <div className="margined-left mobile-mt-2 module panel">
          {this.renderProfile()}
        </div>
      </div>
    );
  }
}

export default PaypalProfile;
